import ToolbarItem from "toolbar/ToolbarItem";
import $ from "jquery";

const LEFT = 1;
const RIGHT = 2;

class Toolbar {

    static addDefaultItem(item, priority = 1, side = Toolbar.LEFT) {
        if (!(item instanceof ToolbarItem)) {
            throw new Error('Item must be an instance of ToolbarItem');
        }
        this.defaultItems.push({item: item, priority: priority, side: side});

        this.update();
    }

    static removeDefaultItem(item) {
        this.defaultItems = this.defaultItems.filter((_item) => _item.item !== item);
        this.update();
    }

    static beforeInit() {
        this.defaultItems = [];
        this.$toolbar = $("<div>").addClass("admin-toolbar");
        this.reset();
        this.loaded = false;
    }

    static init() {
        this.loaded = true;
        this.update();

        if ($(".content-skip-button").length === 0) {
            $("body").prepend(this.$toolbar).addClass("has-toolbar");
        } else {
            $(".content-skip-button").after(this.$toolbar);
            $("body").addClass("has-toolbar");
        }
    }

    static orderItems() {
        this.defaultItems.sort((a, b) => b.priority - a.priority);
    }

    static update() {
        if (!this.loaded) return;
        this.orderItems();
        this.$toolbar.html("");

        const $left = $("<div>").addClass("left");
        const $right = $("<div>").addClass("right");

        this.$toolbar.append([$left, $right]);

        $.each(this.defaultItems, (_, item) => {
            const $item = item.item.getElement();
            if (item.side === Toolbar.LEFT) {
                if (this.usingDefault) {
                    $left.append($item);
                }
            } else if (item.side === Toolbar.RIGHT) {
                $right.append($item);
            } else {
                console.error("Invalid side defined, ", item.side);
            }
        });
        if (!this.usingDefault) {
            $.each(this.items, (side, items) => {
                side = parseInt(side);
                $.each(items, (_, item) => {
                    if (side === Toolbar.LEFT) {
                        $left.append(item.getElement());
                    } else {
                        $right.append(item.getElement());
                    }
                })
            });
        }
    }

    static setItems(items, side = Toolbar.LEFT) {
        this.usingDefault = false;
        this.items[side] = items;
        this.update();
    }

    static reset() {
        this.usingDefault = true;
        this.items = {
            [LEFT]: [],
            [RIGHT]: []
        };
        this.update();
    }
}

Toolbar.LEFT = LEFT;
Toolbar.RIGHT = RIGHT;

Toolbar.beforeInit();
$(function () {
    if ("object" === typeof window.User && window.User !== null && !window.NoToolbar) {
        Toolbar.init();
    }
});

export default Toolbar;
